
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/themes.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-themes-demo-light","docs-x-markdown-themes-demo-dark","docs-x-markdown-themes-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/themes.en-US.md?type=demo')
};